import React, { useState } from "react";
import CommonTable from "../../../../../modules/candidates/Table";

export default function History({
  headerData,
  handleTableBodyData,
  historyList,
}) {
  return (
    <CommonTable
      marginTop="1rem"
      data={historyList.data}
      columns={headerData}
      handleTableBodyData={handleTableBodyData}
      loading={historyList.loading}
      loadingRowLength={3}
    />
  );
}
